var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6177 15.3672C11.7319 15.3672 11.8367 15.3481 11.9319 15.3101C12.0271 15.272 12.1128 15.2148 12.189 15.1387C12.2651 15.0625 12.3223 14.9768 12.3604 14.8816C12.3984 14.7864 12.4175 14.6816 12.4175 14.5674C12.4175 14.4531 12.3984 14.3484 12.3604 14.2532C12.3223 14.158 12.2651 14.0723 12.189 13.9961L7.96143 9.74951L12.189 5.50293C12.2524 5.43945 12.3 5.36011 12.3318 5.26489C12.3635 5.16968 12.3794 5.07764 12.3794 4.98877C12.3794 4.76025 12.3 4.56665 12.1414 4.40796C11.9827 4.24927 11.7954 4.16992 11.5796 4.16992C11.478 4.16992 11.3796 4.18579 11.2844 4.21753C11.1892 4.24927 11.1099 4.29688 11.0464 4.36035L6.24756 9.17822C6.17139 9.2417 6.11108 9.32422 6.06665 9.42578C6.02222 9.52734 6 9.63525 6 9.74951C6 9.86377 6.02222 9.96851 6.06665 10.0637C6.11108 10.1589 6.17139 10.2446 6.24756 10.3208L11.0654 15.1387C11.1289 15.2021 11.2083 15.2561 11.3035 15.3005C11.3987 15.345 11.5034 15.3672 11.6177 15.3672Z",
    fill: "#252F4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrev);
export default __webpack_public_path__ + "static/media/ic-prev.29d1c5a5760e68c7e77383de3ad91d62.svg";
export { ForwardRef as ReactComponent };